import React, { useCallback, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import { Typography, Button } from '@mui/material';
import { useStyles } from '../OrientationOverlay/styles';
import { IReconnectExternalKeyboardButton } from './interfaces';
import { useMytaverseEvent } from '@core/dashboard/providers';
import { getNotification } from '@components/Notification/helpers';
import { NOTIFICATION_TYPES, useNotification } from '@components/Notification';

const ReconnectExternalKeyboardButton = ({
  label,
  fullWidth,
  onReconnectClick,
  showReconnectedNotification = false,
  t: translate,
}: IReconnectExternalKeyboardButton) => {
  const classes = useStyles();
  const { showNotification } = useNotification();
  const isButton = true;

  const { setExternalKeyboardConnected, setShowExternalKeyboardOverlay } =
    useMytaverseEvent();
  const inputRef = React.useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const handleTouchScreen = useCallback(() => {
    console.log('Reconnect external keyboard click');

    setExternalKeyboardConnected(true);
    setShowExternalKeyboardOverlay(false);

    if (showReconnectedNotification) {
      showNotification(
        getNotification({
          message: translate(`notifications.keyboardOrJoystickReconnected`),
          type: NOTIFICATION_TYPES.SUCCESS,
          withDismissButton: false,
          withReloadButton: false,
        }),
      );
    }

    if (onReconnectClick) {
      onReconnectClick();
    }
  }, [setExternalKeyboardConnected, showNotification]);

  const handleClick = useCallback(() => {
    showNotification(
      getNotification({
        message: translate(`notifications.tapToReconnectWarning`),
        type: NOTIFICATION_TYPES.WARNING,
        withDismissButton: false,
        withReloadButton: false,
      }),
    );
  }, [showNotification]);

  return (
    <>
      <Button
        onClick={handleClick}
        onTouchStart={handleTouchScreen}
        /* TODO fix merge conflict sx={classes.button(isButton, fullWidth)} */
        sx={classes.button}
      >
        <Typography>{label}</Typography>
      </Button>
      <input
        type="text"
        inputMode="none"
        ref={inputRef}
        style={{ position: 'fixed', top: '-9999px', left: '-9999px' }}
      />
    </>
  );
};

export default withTranslation()(ReconnectExternalKeyboardButton);
